export default {
  getHead: () => {
    return [{ name: '회사명' }, { name: '종사자 ID(사번)' }, { name: '작성일' }]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.field_name // 회사명
        case 1: return func.onNameBlur(func.getContent(value).inputA_1) // ID
        case 2: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
      case '회사명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
      case '종사자 ID(사번)': returnData.push("content$body.inputA_1*%[:default_skw]%"); break
    }

    return returnData
  },
}
